//  BIKE DATA

var bikes = [
["Argon18", "E-116", "XS", "485", "398"],
["Argon18", "E-116", "S", "495", "411"],
["Argon18", "E-116", "M", "515", "419"],
["Argon18", "E-116", "L", "536", "428"],

["Argon18", "E-114", "XS", "485", "398"],
["Argon18", "E-114", "S", "495", "411"],
["Argon18", "E-114", "M", "515", "419"],
["Argon18", "E-114", "L", "536", "428"],

["Argon18", "E-112", "XS", "485", "398"],
["Argon18", "E-112", "S", "495", "411"],
["Argon18", "E-112", "M", "515", "419"],
["Argon18", "E-112", "L", "536", "428"],

["Argon18", "Mercury", "XS", "499", "391"],
["Argon18", "Mercury", "S", "499", "408"],
["Argon18", "Mercury", "M", "519", "415"],
["Argon18", "Mercury", "L", "536", "425"],

["BH Bikes", "GC Aero", "52", "520", "390"],
["BH Bikes", "GC Aero", "54", "536", "406"],
["BH Bikes", "GC Aero", "56", "560", "420"],
["BH Bikes", "GC Aero", "58", "579", "432"],

["Blue", "T14", "XS", "491", "364"],
["Blue", "T14", "S", "505", "372"],
["Blue", "T14", "M", "513", "395"],
["Blue", "T14", "ML", "526", "407"],
["Blue", "T14", "L", "550", "422"],
["Blue", "T14", "XL", "572", "426"],

["BMC", "TM02", "S", "480", "393"],
["BMC", "TM02", "M-S", "515", "377"],
["BMC", "TM02", "M-L", "515", "418"],
["BMC", "TM02", "L", "556", "442"],

["Boardman", "AirTT/9 series", "XS", "493", "386"],
["Boardman", "AirTT/9 series", "S", "500", "404"],
["Boardman", "AirTT/9 series", "M", "519", "419"],
["Boardman", "AirTT/9 series", "L", "537", "435"],

["Canyon", "Speedmax AL", "XS", "485", "404"],
["Canyon", "Speedmax AL", "S", "499", "420"],
["Canyon", "Speedmax AL", "M", "518", "430"],
["Canyon", "Speedmax AL", "L", "537", "440"],
["Canyon", "Speedmax AL", "XL", "565", "457"],

["Canyon", "Speedmax CF", "XS", "481", "397"],
["Canyon", "Speedmax CF", "S", "510", "405"],
["Canyon", "Speedmax CF", "M", "533", "425"],
["Canyon", "Speedmax CF", "L", "555", "435"],
["Canyon", "Speedmax CF", "XL", "582", "455"],

["Cannondale", "Slice (pre-2015)", "47", "478", "365"],
["Cannondale", "Slice (pre-2015)", "51", "494", "371"],
["Cannondale", "Slice (pre-2015)", "54", "509", "398"],
["Cannondale", "Slice (pre-2015)", "56", "529", "407"],
["Cannondale", "Slice (pre-2015)", "58", "548", "417"],
["Cannondale", "Slice (pre-2015)", "60", "572", "425"],

["Cannondale", "Slice (2015+)", "44", "465", "360"],
["Cannondale", "Slice (2015+)", "48", "487", "375"],
["Cannondale", "Slice (2015+)", "51", "507", "390"],
["Cannondale", "Slice (2015+)", "54", "527", "405"],
["Cannondale", "Slice (2015+)", "57", "547", "420"],
["Cannondale", "Slice (2015+)", "60", "567", "435"],

["Cervelo", "P5", "45", "450", "375"],
["Cervelo", "P5", "48", "485", "381"],
["Cervelo", "P5", "51", "506", "397"],
["Cervelo", "P5", "54", "522", "411"],
["Cervelo", "P5", "56", "540", "425"],
["Cervelo", "P5", "58", "559", "437"],
["Cervelo", "P5", "61", "588", "446"],

["Cervelo", "P4", "48", "461", "389"],
["Cervelo", "P4", "51", "482", "405"],
["Cervelo", "P4", "54", "498", "419"],
["Cervelo", "P4", "56", "516", "433"],
["Cervelo", "P4", "58", "535", "445"],
["Cervelo", "P4", "61", "564", "454"],

["Cervelo", "P3 (2014+)", "45", "450", "375"],
["Cervelo", "P3 (2014+)", "48", "485", "381"],
["Cervelo", "P3 (2014+)", "51", "506", "397"],
["Cervelo", "P3 (2014+)", "54", "522", "411"],
["Cervelo", "P3 (2014+)", "56", "540", "425"],
["Cervelo", "P3 (2014+)", "58", "559", "437"],
["Cervelo", "P3 (2014+)", "61", "588", "446"],

["Cervelo", "P2 (2014+)", "45", "450", "375"],
["Cervelo", "P2 (2014+)", "48", "485", "381"],
["Cervelo", "P2 (2014+)", "51", "506", "397"],
["Cervelo", "P2 (2014+)", "54", "522", "411"],
["Cervelo", "P2 (2014+)", "56", "540", "425"],
["Cervelo", "P2 (2014+)", "58", "559", "437"],
["Cervelo", "P2 (2014+)", "61", "588", "446"],

["Cervelo", "P3 (pre-2014)", "48", "461", "389"],
["Cervelo", "P3 (pre-2014)", "51", "482", "405"],
["Cervelo", "P3 (pre-2014)", "54", "498", "419"],
["Cervelo", "P3 (pre-2014)", "56", "516", "433"],
["Cervelo", "P3 (pre-2014)", "58", "535", "445"],
["Cervelo", "P3 (pre-2014)", "61", "564", "454"],

["Cervelo", "P2 (pre-2014)", "48", "461", "389"],
["Cervelo", "P2 (pre-2014)", "51", "482", "405"],
["Cervelo", "P2 (pre-2014)", "54", "512", "418"],
["Cervelo", "P2 (pre-2014)", "56", "531", "429"],
["Cervelo", "P2 (pre-2014)", "58", "550", "440"],
["Cervelo", "P2 (pre-2014)", "61", "577", "447"],

["Cervelo", "P1", "48", "461", "389"],
["Cervelo", "P1", "51", "482", "405"],
["Cervelo", "P1", "54", "512", "418"],
["Cervelo", "P1", "56", "531", "429"],
["Cervelo", "P1", "58", "550", "440"],
["Cervelo", "P1", "61", "577", "447"],

["Cube", "Aerium", "S", "500", "395"],
["Cube", "Aerium", "M", "514", "416"],
["Cube", "Aerium", "L", "530", "437"],
["Cube", "Aerium", "XL", "549", "453"],

["Cube", "Super HPC", "S", "500", "395"],
["Cube", "Super HPC", "M", "514", "416"],
["Cube", "Super HPC", "L", "530", "437"],
["Cube", "Super HPC", "XL", "549", "453"],

["Dimond", "2015 Dimond Bike", "S", "515", "405"],
["Dimond", "2015 Dimond Bike", "M", "540", "425"],
["Dimond", "2015 Dimond Bike", "L", "565", "440"],

["Falco", "2015 V", "S (TBD)", "500", "379"],
["Falco", "2015 V", "M", "528", "394"],
["Falco", "2015 V", "L", "558", "409"],

["Felt", "B-Series (pre-2013)", "48", "467", "386"],
["Felt", "B-Series (pre-2013)", "50", "483", "391"],
["Felt", "B-Series (pre-2013)", "52", "502", "406"],
["Felt", "B-Series (pre-2013)", "54", "513", "414"],
["Felt", "B-Series (pre-2013)", "56", "527", "426"],
["Felt", "B-Series (pre-2013)", "58", "546", "449"],
["Felt", "B-Series (pre-2013)", "60", "561", "461"],

["Felt", "B-Series (2013+)", "47", "468", "375"],
["Felt", "B-Series (2013+)", "51", "521", "388"],
["Felt", "B-Series (2013+)", "54", "536", "405"],
["Felt", "B-Series (2013+)", "56", "556", "420"],
["Felt", "B-Series (2013+)", "58", "576", "435"],
["Felt", "B-Series (2013+)", "61", "606", "443"],

["Felt", "IA 10, IA 12, IA 14, IA 16", "XS (48)", "467", "380"],
["Felt", "IA 10, IA 12, IA 14, IA 16", "S (51)", "489", "395"],
["Felt", "IA 10, IA 12, IA 14, IA 16", "M (54)", "513", "405"],
["Felt", "IA 10, IA 12, IA 14, IA 16", "L (56)", "537", "424"],
["Felt", "IA 10, IA 12, IA 14, IA 16", "XL (58)", "559", "443"],

["Felt", "IA 1, IA 2, IA 3, IA 4", "XS (48)", "478", "379"],
["Felt", "IA 1, IA 2, IA 3, IA 4", "S (51)", "505", "387"],
["Felt", "IA 1, IA 2, IA 3, IA 4", "M (54)", "522", "404"],
["Felt", "IA 1, IA 2, IA 3, IA 4", "L (56)", "546", "425"],
["Felt", "IA 1, IA 2, IA 3, IA 4", "XL (58)", "572", "445"],

["Fuji", "D6", "XS (48)", "481", "354"],
["Fuji", "D6", "S (50)", "490", "372"],
["Fuji", "D6", "S/M (52)", "500", "390"],
["Fuji", "D6", "M (54)", "509", "402"],
["Fuji", "D6", "M/L (56)", "525", "424"],
["Fuji", "D6", "L (58)", "525", "445"],
["Fuji", "D6", "XL (60)", "538", "460"],

["Giant", "Trinity Alliance", "XS", "503", "397"],
["Giant", "Trinity Alliance", "S", "517", "410"],
["Giant", "Trinity Alliance", "M", "533", "427"],
["Giant", "Trinity Alliance", "L", "548", "449"],

["Giant", "Trinity", "XS", "503", "397"],
["Giant", "Trinity", "S", "517", "410"],
["Giant", "Trinity", "M", "533", "427"],
["Giant", "Trinity", "L", "548", "449"],

["Jamis", "Xenith T1", "Small", "496", "405"],
["Jamis", "Xenith T1", "Medium", "509", "417"],
["Jamis", "Xenith T1", "MedLrg", "531", "432"],
["Jamis", "Xenith T1", "Large", "556", "457"],

["Jamis", "Xenith T2", "Small", "496", "405"],
["Jamis", "Xenith T2", "Medium", "509", "417"],
["Jamis", "Xenith T2", "MedLrg", "531", "432"],
["Jamis", "Xenith T2", "Large", "556", "457"],

["Jamis", "Trilogy", "51", "493", "402"],
["Jamis", "Trilogy", "54", "506", "415"],
["Jamis", "Trilogy", "56", "525", "430"],
["Jamis", "Trilogy", "58", "539", "447"],
["Jamis", "Trilogy", "61", "553", "454"],

["Jamis", "Comet", "51", "493", "402"],
["Jamis", "Comet", "54", "506", "415"],
["Jamis", "Comet", "56", "525", "431"],
["Jamis", "Comet", "58", "539", "447"],
["Jamis", "Comet", "61", "554", "454"],

["Kestrel", "Airfoil Pro", "47", "437", "399"],
["Kestrel", "Airfoil Pro", "50", "466", "409"],
["Kestrel", "Airfoil Pro", "52", "484", "415"],
["Kestrel", "Airfoil Pro", "54", "503", "426"],
["Kestrel", "Airfoil Pro", "56", "521", "431"],
["Kestrel", "Airfoil Pro", "59", "550", "439"],

["Kestrel", "4000, 4000Pro, 4000LTD", "47", "467", "397"],
["Kestrel", "4000, 4000Pro, 4000LTD", "50", "525", "394"],
["Kestrel", "4000, 4000Pro, 4000LTD", "52.5", "530", "403"],
["Kestrel", "4000, 4000Pro, 4000LTD", "55", "536", "418"],
["Kestrel", "4000, 4000Pro, 4000LTD", "57.5", "541", "440"],
["Kestrel", "4000, 4000Pro, 4000LTD", "59.5", "547", "450"],

["LOOK", "576", "S", "522", "387"],
["LOOK", "576", "MD", "547", "401"],
["LOOK", "576", "LG", "561", "429"],
["LOOK", "576", "XL", "580", "450"],

["Orbea", "Ordu (pre-2013)", "48", "497", "375"],
["Orbea", "Ordu (pre-2013)", "51", "512", "395"],
["Orbea", "Ordu (pre-2013)", "54", "520", "409"],
["Orbea", "Ordu (pre-2013)", "57", "530", "422"],

["Orbea", "Ordu OMP", "XS", "465", "370"],
["Orbea", "Ordu OMP", "SM", "490", "390"],
["Orbea", "Ordu OMP", "MD", "515", "410"],
["Orbea", "Ordu OMP", "LG", "540", "430"],
["Orbea", "Ordu OMP", "XL", "565", "445"],

["Orbea", "Ora", "48", "497", "375"],
["Orbea", "Ora", "51", "512", "395"],
["Orbea", "Ora", "54", "520", "409"],
["Orbea", "Ora", "57", "530", "422"],

["Orbea", "Aletta", "XS", "506", "385"],
["Orbea", "Aletta", "S", "527", "400"],
["Orbea", "Aletta", "M", "542", "412"],
["Orbea", "Aletta", "L", "558", "429"],
["Orbea", "Aletta", "XL", "598", "429"],

["Orbea", "Aletta Dama", "XS", "509", "375"],
["Orbea", "Aletta Dama", "S", "530", "380"],
["Orbea", "Aletta Dama", "M", "546", "391"],

["Quintana Roo", "Kilo (2011+)", "XS", "453", "393"],
["Quintana Roo", "Kilo (2011+)", "S", "502", "388"],
["Quintana Roo", "Kilo (2011+)", "M", "527", "403"],
["Quintana Roo", "Kilo (2011+)", "L", "568", "424"],

["Quintana Roo", "Lucero (2011+)", "XS", "453", "393"],
["Quintana Roo", "Lucero (2011+)", "S", "502", "388"],
["Quintana Roo", "Lucero (2011+)", "M", "527", "403"],
["Quintana Roo", "Lucero (2011+)", "L", "568", "424"],

["Quintana Roo", "PRFive", "48", "480", "380"],
["Quintana Roo", "PRFive", "50", "500", "390"],
["Quintana Roo", "PRFive", "52", "520", "410"],
["Quintana Roo", "PRFive", "54", "540", "425"],
["Quintana Roo", "PRFive", "56", "560", "435"],
["Quintana Roo", "PRFive", "58.5", "585", "445"],

["Quintana Roo", "Seduza (2011+)", "XS", "453", "393"],
["Quintana Roo", "Seduza (2011+)", "S", "502", "388"],
["Quintana Roo", "Seduza (2011+)", "M", "527", "403"],
["Quintana Roo", "Seduza (2011+)", "L", "568", "424"],

["Quintana Roo", "CD0.1", "S", "497", "396"],
["Quintana Roo", "CD0.1", "M", "497", "420"],
["Quintana Roo", "CD0.1", "ML", "517", "438"],
["Quintana Roo", "CD0.1", "L", "545", "452"],

["Quintana Roo", "Illicito", "S", "497", "396"],
["Quintana Roo", "Illicito", "M", "497", "420"],
["Quintana Roo", "Illicito", "ML", "517", "438"],
["Quintana Roo", "Illicito", "L", "545", "452"],

["Quintana Roo", "Tequilo (pre-2011)", "46", "450", "380"],
["Quintana Roo", "Tequilo (pre-2011)", "49", "500", "400"],
["Quintana Roo", "Tequilo (pre-2011)", "52", "500", "420"],
["Quintana Roo", "Tequilo (pre-2011)", "55", "517", "435"],
["Quintana Roo", "Tequilo (pre-2011)", "58", "550", "448"],
["Quintana Roo", "Tequilo (pre-2011)", "61", "578", "461"],

["Quintana Roo", "Dulce (pre-2011)", "XS", "453", "394"],
["Quintana Roo", "Dulce (pre-2011)", "S", "486", "388"],
["Quintana Roo", "Dulce (pre-2011)", "M", "514", "407"],
["Quintana Roo", "Dulce (pre-2011)", "L", "550", "430"],

["Quintana Roo", "Seduza (pre-2011)", "XS", "453", "394"],
["Quintana Roo", "Seduza (pre-2011)", "S", "486", "388"],
["Quintana Roo", "Seduza (pre-2011)", "M", "514", "407"],
["Quintana Roo", "Seduza (pre-2011)", "L", "550", "430"],

["Quintana Roo", "Caliente (pre-2011)", "XS", "453", "394"],
["Quintana Roo", "Caliente (pre-2011)", "S", "486", "388"],
["Quintana Roo", "Caliente (pre-2011)", "M", "514", "407"],
["Quintana Roo", "Caliente (pre-2011)", "L", "550", "430"],

["Quintana Roo", "Lucero (pre-2011)", "XS", "453", "394"],
["Quintana Roo", "Lucero (pre-2011)", "S", "486", "388"],
["Quintana Roo", "Lucero (pre-2011)", "M", "514", "407"],
["Quintana Roo", "Lucero (pre-2011)", "L", "550", "430"],

["Scott", "Plasma 1", "XS", "504", "379"],
["Scott", "Plasma 1", "S", "515", "392"],
["Scott", "Plasma 1", "M", "527", "404"],
["Scott", "Plasma 1", "L", "548", "416"],
["Scott", "Plasma 1", "XL", "581", "427"],

["Scott", "Plasma 2", "XS", "504", "379"],
["Scott", "Plasma 2", "S", "515", "392"],
["Scott", "Plasma 2", "M", "527", "404"],
["Scott", "Plasma 2", "L", "548", "416"],
["Scott", "Plasma 2", "XL", "581", "427"],

["Scott", "Plasma 10, Plasma 20 (2015+)", "S/51", "500", "383"],
["Scott", "Plasma 10, Plasma 20 (2015+)", "M/54", "530", "400"],
["Scott", "Plasma 10, Plasma 20 (2015+)", "L/57", "560", "417"],
["Scott", "Plasma 10, Plasma 20 (2015+)", "XL/60", "600", "430"],

["Specialized", "Alias", "44", "518", "358"],
["Specialized", "Alias", "48", "531", "370"],
["Specialized", "Alias", "51", "546", "370"],
["Specialized", "Alias", "54", "567", "374"],
["Specialized", "Alias", "57", "590", "390"],

["Specialized", "Shiv", "XS", "495", "365"],
["Specialized", "Shiv", "S", "515", "385"],
["Specialized", "Shiv", "M", "540", "405"],
["Specialized", "Shiv", "L", "565", "425"],
["Specialized", "Shiv", "XL", "590", "445"],

["Specialized", "Shiv TT", "XS", "481", "375"],
["Specialized", "Shiv TT", "S", "495", "390"],
["Specialized", "Shiv TT", "M", "495", "405"],
["Specialized", "Shiv TT", "L", "495", "420"],
["Specialized", "Shiv TT", "XL", "495", "440"],

["Specialized", "Transition", "XSmall", "487", "365"],
["Specialized", "Transition", "Small", "505", "380"],
["Specialized", "Transition", "Medium", "516", "395"],
["Specialized", "Transition", "Large", "526", "405"],
["Specialized", "Transition", "XLarge", "542", "421"],
["Specialized", "Transition", "XXLarge", "554", "450"],

["Trek", "Equinox TTX", "S", "515", "391"],
["Trek", "Equinox TTX", "M", "524", "419"],
["Trek", "Equinox TTX", "L", "564", "429"],

["Trek", "Equinox 7", "50", "485", "389"],
["Trek", "Equinox 7", "52", "505", "400"],
["Trek", "Equinox 7", "54", "526", "414"],
["Trek", "Equinox 7", "56", "544", "420"],
["Trek", "Equinox 7", "58", "564", "435"],
["Trek", "Equinox 7", "60", "591", "448"],

["Trek", "Equinox 7 WSD", "47", "485", "380"],
["Trek", "Equinox 7 WSD", "51", "518", "381"],
["Trek", "Equinox 7 WSD", "54", "548", "388"],

["TriRig", "Omni", "Small", "490", "375"],
["TriRig", "Omni", "Medium", "525", "405"],
["TriRig", "Omni", "Large", "560", "435"],

["Ventum", "Ventum One", "46", "492", "381"],
["Ventum", "Ventum One", "51", "510", "393"],
["Ventum", "Ventum One", "54", "528", "409"],
["Ventum", "Ventum One", "56", "545", "422"],
["Ventum", "Ventum One", "58", "564", "437"],

["Ventum", "Ventum Z", "46", "492", "381"],
["Ventum", "Ventum Z", "51", "510", "393"],
["Ventum", "Ventum Z", "54", "528", "409"],
["Ventum", "Ventum Z", "56", "545", "422"],
["Ventum", "Ventum Z", "58", "564", "437"],

["Wilier", "Cento Crono", "S", "499", "402"],
["Wilier", "Cento Crono", "M", "523", "438"],
["Wilier", "Cento Crono", "L", "539", "470"],

]

var bikesNotCompatible = [

["Blue", "Triad", "SM", "520", "378"], //Alpha Classic only
["Blue", "Triad", "MD", "539", "398"],
["Blue", "Triad", "ML", "558", "414"],
["Blue", "Triad", "LG", "577", "429"],

["BMC", "TM01", "S", "480", "393"], //Alpha Classic only
["BMC", "TM01", "M-S", "515", "377"],
["BMC", "TM01", "M-L", "515", "418"],
["BMC", "TM01", "L", "556", "442"],

["Canyon", "2015 Speedmax CF", "S", "499", "410"], //NOT compatible
["Canyon", "2015 Speedmax CF", "M", "519", "432"],
["Canyon", "2015 Speedmax CF", "L", "539", "457"],

["LOOK", "596", "XS-HI", "476", "386"], //Alpha Classic Only
["LOOK", "596", "XS-LO", "462", "391"],
["LOOK", "596", "S-HI", "478", "403"],
["LOOK", "596", "S-LO", "463", "408"],
["LOOK", "596", "M-HI", "524", "410"],
["LOOK", "596", "M-LO", "509", "414"],
["LOOK", "596", "L-HI", "524", "426"],
["LOOK", "596", "L-LO", "509", "430"],

["Felt", "DA1, DA2, DA3, DA4", "47", "433", "387"], //Alpha Classic only
["Felt", "DA1, DA2, DA3, DA4", "51", "488", "389"],
["Felt", "DA1, DA2, DA3, DA4", "54", "497", "416"],
["Felt", "DA1, DA2, DA3, DA4", "56", "516", "432"],
["Felt", "DA1, DA2, DA3, DA4", "58", "536", "447"],

["Cannondale", "Slice RS", "50", "459", "382"], //Alpha Classic only
["Cannondale", "Slice RS", "52", "469", "396"],
["Cannondale", "Slice RS", "54", "489", "405"],
["Cannondale", "Slice RS", "56", "509", "414"],
["Cannondale", "Slice RS", "58", "529", "424"],

["Orbea", "Ordu (2013+)", "48", "467", "381"], //Alpha Classic Only
["Orbea", "Ordu (2013+)", "51", "501", "395"],
["Orbea", "Ordu (2013+)", "54", "517", "415"],
["Orbea", "Ordu (2013+)", "57", "552", "444"],

["Trek", "Speed Concept, Gen 1 (2009-2013)", "XS", "468", "370"], //Technically compatible, requires steerer stub
["Trek", "Speed Concept, Gen 1 (2009-2013)", "S", "492", "390"],
["Trek", "Speed Concept, Gen 1 (2009-2013)", "M", "517", "408"],
["Trek", "Speed Concept, Gen 1 (2009-2013)", "L", "541", "426"],
["Trek", "Speed Concept, Gen 1 (2009-2013)", "XL", "565", "445"],



]


//  STEM DATA
//  Measurements for Traditional Stems assume 72.5-degree head tube angle
//  and 45mm steerer clamp zone

var stems = [
    ["TriRig Sigma X Carbon", 25, 100],
    ["TriRig Sigma XF", 22, 90],
    ["TriRig Sigma N35", 56, 90],
    
	["Traditional Stem: -6 degrees, 80mm", 37, 72],
    ["Traditional Stem: -6 degrees, 90mm", 39, 81],
    ["Traditional Stem: -6 degrees, 100mm", 41, 91],
    ["Traditional Stem: -6 degrees, 110mm", 43, 101],
    ["Traditional Stem: -6 degrees, 120mm", 45, 111],
	
	["Traditional Stem: -17 degrees, 80mm", 22, 73],
    ["Traditional Stem: -17 degrees, 90mm", 22, 83],
    ["Traditional Stem: -17 degrees, 100mm", 22, 93],
    ["Traditional Stem: -17 degrees, 110mm", 22, 103],
    ["Traditional Stem: -17 degrees, 120mm", 23, 113],
    
	["Traditional Stem: +6 degrees, 80mm", 53, 67],
    ["Traditional Stem: +6 degrees, 90mm", 57, 76],
    ["Traditional Stem: +6 degrees, 100mm", 61, 85],
    ["Traditional Stem: +6 degrees, 110mm", 65, 94],
    ["Traditional Stem: +6 degrees, 120mm", 69, 103],
	
	["Traditional Stem: +17 degrees, 80mm", 67, 59],
    ["Traditional Stem: +17 degrees, 90mm", 72, 67],
    ["Traditional Stem: +17 degrees, 100mm", 78, 76],
    ["Traditional Stem: +17 degrees, 110mm", 84, 84],
    ["Traditional Stem: +17 degrees, 120mm", 89, 98],
    
	["Integrated Stem", 0, 0],
]

//Constants
var STACK_PREFIX = "Stack-";
var REACH_PREFIX = "Reach-";

//These are filled from the HTML via inputs with IDs of the same name
//in document ready function
var DEFAULT_TITLE = "";
var BRAND_TITLE = "";
var CUSTOM_TITLE = "";

//Indexes to columns in the bikes array
var BRAND = 0;
var MODEL = 1;
var SIZE = 2;
var STACK = 3;
var REACH = 4;
var STEM_STACK = 1;
var STEM_REACH = 2;

//Set in document ready if stem dropdown exists
var USE_STEM = false;

//Used to keep track of whether user entered a custom stack/reach or picked a brand
var CUSTOM = false;

$( document ).ready(function() {

	//If there is a stem drop down on the html page
	//activate the stem logic
	if ($('#stemddl').length > 0)
	{
		USE_STEM = true;
	}

	//extract titles from html page
	DEFAULT_TITLE = $('#DEFAULT_TITLE').val();
	BRAND_TITLE = $('#BRAND_TITLE').val();
	CUSTOM_TITLE = $('#CUSTOM_TITLE').val();
	
	populateBrands();
	populateStems();
	setDefaultOptions();
	   
});

function setDefaultOptions()
{	
	//If default brand/model/size are coded in the html, use them
	if ($('#DEFAULT_BRAND').length > 0)
	{
		document.getElementById('brandddl').value = $('#DEFAULT_BRAND').val();
		brandSelected();	
		
		if ($('#DEFAULT_MODEL').length > 0)
		{
			document.getElementById('modelddl').value = $('#DEFAULT_MODEL').val();
			modelSelected();
			
			if ($('#DEFAULT_SIZE').length > 0)
			{
				document.getElementById('sizeddl').value = $('#DEFAULT_SIZE').val();
				sizeSelected();
			} 
		}
	}	

}

function brandSelected()
{
	CUSTOM = false;

	revertToDefault();
	populateModels();
}

function modelSelected()
{
	
	revertToDefault();	
	populateSizes();
}

function sizeSelected()
{

	if ($('#sizeddl')[0].selectedIndex == 0)
	{
		revertToDefault();
		return;
	}
	if (USE_STEM && $('#stemddl')[0].selectedIndex == 0) {		
		setFrameStackReachInputs();
	}
	else {
		setFrameStackReachInputs();
		setFit();
	}
}

function stemSelected()
{
	
	if ( $('#stemddl')[0].selectedIndex == 0) {
		tableReset();
		return;
	}

	var stack = parseInt($('#stackinput').val());
	var reach = parseInt($('#reachinput').val());

	if (isNaN(stack) || isNaN(reach)) return;

	if (CUSTOM)
	{		
		setFitCustom(stack,reach);
	} else {

		setFit();
	}
}

function revertToDefault()
{
		tableReset();
		$('#stackinput').val("");
		$('#reachinput').val("");
}

function tableReset()
{
		fillStackValues(0);
		fillReachValues(0);
		$('#Chart-Title').html(DEFAULT_TITLE);
}



//when user finally selects a size, this is called
function setFrameStackReachInputs()
{
    var brand = $('#brandddl').val();
	var model = $('#modelddl').val();
	var size = $('#sizeddl').val();

	var frameStackReach;

	frameStackReach = getFrameStackReach(bikes,brand,model,size);

	var frameStack = frameStackReach[0];
	var frameReach = frameStackReach[1];

	$('#stackinput').val(frameStack);
	$('#reachinput').val(frameReach);

}

function setFit()
{
	var brand = $('#brandddl').val();
	var model = $('#modelddl').val();
	var size = $('#sizeddl').val();

	var frameStackReach;
	frameStackReach = getFrameStackReach(bikes,brand,model,size);

	var stemStackReach = [0,0];

	if (USE_STEM) {		
		var stem = $('#stemddl').val();	
		stemStackReach = getStemStackReach(stem);
	} 

	fillStackValues(frameStackReach[0]+stemStackReach[0]);
	fillReachValues(frameStackReach[1]+stemStackReach[1]);

	//set the chart title, replacing the brand/model/size
	var titlestring = BRAND_TITLE.replace("BRAND",brand);
	titlestring = titlestring.replace("MODEL",model);
	titlestring = titlestring.replace("SIZE",size);
	if (USE_STEM) {
		var stem = $('#stemddl').val();
		titlestring = titlestring.replace("STEM",stem);
	}
	$('#Chart-Title').html(titlestring);
}

//used when a user types in a stack/reach value
function setFitCustom(stack,reach)
{
		var titlestring = CUSTOM_TITLE.replace("STACK",stack);
		titlestring = titlestring.replace("REACH",reach);
		if (USE_STEM) {
			var stem = $('#stemddl').val();
			titlestring = titlestring.replace("STEM",stem);
			var stemStackReach = getStemStackReach(stem);

			stack += stemStackReach[0];
			reach += stemStackReach[1];
		}
		$('#Chart-Title').html(titlestring);

		if (stack == 0 && reach == 0)
		{
			$('#Chart-Title').html(DEFAULT_TITLE);
		}

		fillStackValues(stack);
		fillReachValues(reach);
}

function stackReachChangedByKeypress()
{
	CUSTOM = true;
	populateBrands();
	var stack = $('#stackinput').val();
	stack = parseInt(stack);		
	var reach = $('#reachinput').val();
	reach = parseInt(reach);


	//check if data is valid number
	if (isNaN(stack)) 
	{
		stack = 0;
		$('#stackinput').val('');
	}

	if (isNaN(reach)) {
		reach = 0;
		$('#reachinput').val('');
	}

	//nothing really entered
	if (stack == 0 && reach == 0) return;

	if (USE_STEM) {		

		var selectedIndex = $('#stemddl')[0].selectedIndex;
		if (selectedIndex != 0) {
			setFitCustom(stack,reach);
		}
		
	} else {
		setFitCustom(stack,reach);
	}
}



function fillReachValues(reach)
{
	var reachCells = $("span[id^='"+REACH_PREFIX+"']");

	//add frame reach to cell reach
	reachCells.each(function (i) {		
		var cellReachText = $(this).attr("id");
		var index = REACH_PREFIX.length;
		var cellReach = cellReachText.substring(index);
		cellReach = parseInt(cellReach);
		cellReach += reach;
		$(this).html(cellReach);
	});
}

function fillStackValues(stack) {

	var stackCells = $("span[id^='"+STACK_PREFIX+"']");

	stackCells.each(function (i) {		
		var cellStackText = $(this).attr("id");
		var index = STACK_PREFIX.length;
		var cellStack = cellStackText.substring(index);
		cellStack = parseInt(cellStack);
		cellStack += stack;
		$(this).html(cellStack);
	});



}

function clearDropdowns()
{
	

	var sizeddl = $('#sizeddl');
	sizeddl.empty();
	sizeddl.prop("disabled",true);
	var modelddl = $('#modelddl');
	modelddl.empty();
	modelddl.prop("disabled",true);


	$('#Chart-Title').html(DEFAULT_TITLE);
	fillStackValues(0);
	fillReachValues(0);
}

function populateBrands()
{
	clearDropdowns();

    var brands = getBrandsFromBikes(bikes);
    var brandddl = $('#brandddl');
    brandddl.empty();
    brandddl.append($('<option></option>').val("").html("Select Brand"));
	for (i = 0; i < brands.length; i++)
	{
		brandddl.append($('<option></option').val(brands[i]).html(brands[i]));
	}
	brandddl.prop("disabled",false);
}




function populateModels()
{
	//clear children
	var sizeddl = $('#sizeddl');
	sizeddl.empty();
	sizeddl.prop("disabled",true);

	var brand = $('#brandddl').val();
	var models = getModelsFromBrand(bikes,brand);
	var modelddl = $('#modelddl');
	modelddl.empty();
	modelddl.append($('<option></option>').val("").html("Select Model"));
	for (i = 0; i < models.length; i++)
	{
		modelddl.append($('<option></option>').val(models[i]).html(models[i]));
	}
	modelddl.removeProp("disabled");
	modelddl.removeAttr("disabled");
  
}	

function populateSizes()
{
	var brand = $('#brandddl').val();
	var model = $('#modelddl').val();
	var sizes = getSizesFromBrandAndModel(bikes,brand,model);
	var sizeddl = $('#sizeddl');
	sizeddl.empty();
	sizeddl.append($('<option></option>').val("").html("Select Size"));
	
	//Disable "Select Size title" if we are forcing a default size
	if ($('#DEFAULT_SIZE').length > 0)
	{
		var op = document.getElementById("sizeddl").getElementsByTagName("option");
		op[0].disabled = true;
	}
	for (i = 0; i < sizes.length; i++)
	{
		sizeddl.append($('<option></option>').val(sizes[i]).html(sizes[i]));
	}
	sizeddl.removeProp("disabled",false);
    sizeddl.removeAttr("disabled");
}

function populateStems()
{
	//get stem names from stem array
	var stemNames = new Array();
    for (i = 0; i < stems.length; i++)
    {
    	var stem = stems[i];
    	var stemName = stems[i][BRAND];
    	stemNames.pushIfNotExists(stemName);

    }

    //populate the ddl
    var stemddl = $('#stemddl');
    stemddl.empty();
    stemddl.append($('<option></option>').val("").html("Select Stem"));
    for (i = 0; i < stemNames.length; i++)
    {
    	stemddl.append($('<option></option').val(stemNames[i]).html(stemNames[i]));
    }
    stemddl.removeProp("disabled",false);

}

function getBrandsFromBikes(bikes)
{
    var brands = new Array();
    for (i = 0; i < bikes.length; i++)
    {
    	var bike = bikes[i];
    	var brand = bikes[i][BRAND];
    	brands.pushIfNotExists(brand);

    }
    return brands.sort();
}

function getModelsFromBrand(bikes,brand)
{
    var models = new Array();
    for (i = 0; i < bikes.length; i++)
    {
    	if (bikes[i][BRAND] == brand)
    	{
    		models.pushIfNotExists(bikes[i][MODEL]);
    	}
   	}
   	return models;
}

function getSizesFromBrandAndModel(bikes,brand,model)
 {
 	var sizes = new Array();
    for (i = 0; i < bikes.length; i++)
    {    	
    	if ((bikes[i][BRAND] == brand) && (bikes[i][MODEL] == model))
    	{    		
    		sizes.pushIfNotExists(bikes[i][SIZE]);
    	}
   	}
   	return sizes;
 }

 function getStemStackReach(stem) {

 	var stackReach = new Array();
 	for (i = 0; i < stems.length; i++)
 	{
 		if (stems[i][0] == stem)
 		{

 			stackReach.push(parseInt(stems[i][STEM_STACK]));
 			stackReach.push(parseInt(stems[i][STEM_REACH]));
 		}
 	}

 	return stackReach;
 }

 function getFrameStackReach(bikes,brand,model,size)
 {
  	var stackReach = new Array();
    for (i = 0; i < bikes.length; i++)
    {    	
    	if ((bikes[i][BRAND] == brand) && (bikes[i][MODEL] == model) && (bikes[i][SIZE] == size))
    	{    		
    		stackReach.push(parseInt(bikes[i][STACK]));
    		stackReach.push(parseInt(bikes[i][REACH]));
    	}
   	}
   	return stackReach;
 }


Array.prototype.pushIfNotExists = function (str)
{

    if (jQuery.inArray(str,this) == -1)
    {
    	this.push(str);
    }
}

